import EntityModel from '@/common/models/entity-model';

export default class OrderLineItemSubtotalModel extends EntityModel {
    hydrate({
        amount = null,
        currency = null,
    } = {}) {
        this.amount = amount;
        this.currency = currency;
    }

    getPayload() {
        return {
            amount: this.amount,
            currency: this.currency,
        };
    }
}
